import { PayloadState } from '../../types';

export const initialState: PayloadState = {
  data: {
    relationshipType: '',
    accountType: '',
    requestType: '',
    onBehalf: '',
    deliveryMethod: '',
    consumerFirstName: '',
    consumerMiddleName: '',
    consumerLastName: '',
    consumerSuffix: '',
    consumerEmail: '',
    consumerPhoneNumber: '',
    consumerAccountNumber: '',
    consumerDateOfBirth: '',
    consumerStreetAddress: '',
    consumerAddressLine2: '',
    consumerCity: '',
    consumerState: '',
    consumerZip: '',
    agentFirstName: '',
    agentMiddleName: '',
    agentLastName: '',
    agentSuffix: '',
    agentEmail: '',
    agentPhoneNumber: '',
    agentDateOfBirth: '',
    agentStreetAddress: '',
    agentAddressLine2: '',
    agentCity: '',
    agentState: '',
    agentZip: '',
    formAttachments: [],
    submittedBy: '',
    dateExtension: '',
    onlineResponse: '',
    responseForm: '',
  },
  submitting: false,
  submitted: false,
  error: false
}